import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

export function BioConfigForm({ config, onUpdate }) {
  return (
    <div className="space-y-4">
      <div>
        <Label className="text-white">Tags</Label>
        {/* Add tag input component */}
      </div>
    </div>
  );
}
